import React from "react";
import ResidenciesWrap from "./ResidenciesWrap";

function Residencies(props) {
    const { item_id } = props.match.params;
    return (
        <>
            <ResidenciesWrap />
        </>
    )
}

export default Residencies;
